import { useNavigation } from '@react-navigation/native'
import _ from 'lodash'
import FetchManagementEmployee from 'utils/fetch/management/FetchManagementEmployee'
import { listArrow } from 'styles/list'
import { AppRoutes } from 'navigations/app-routes'
import { constantsActive, constantsGraphql } from 'utils/constants/constants'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import React, { useEffect, useState } from 'react'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import i18n from 'utils/i18n'
import { createPagination } from 'utils/helper-pagination'
import ListItem from 'components/atoms/ListItem'
import HelperString from 'utils/helper-string'

const TeamsEmployees = () => {
	const navigation = useNavigation();
	
	const [ searching, setSearching ] = useState( false )
	const [ search, setSearch ] = useState('')
	const [ employees, setEmployees ] = useState( [] )
	
	const openEmployee = ( employee ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_EMPLOYEES_EMPLOYEE_VIEW, {
			employeeGuid: employee.guid
		} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ item.name }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openEmployee }
			/>
		)
	}
	
	const fetchEmployees = ( value = '' ) => {
		// Always lowercaseee
		value = value?.toLowerCase() ?? '';
		
		setSearch( value )
		
		let variables = {};
		
		// No search is default
		if( HelperString.isEmptyString( value ) ) {
			variables = {
				...variables,
				...createPagination( 20, 1 )
			}
		}
		
		// Only when there is a value do a fetch :)
		FetchManagementEmployee.fetchAll({
			variables: {
				...variables,
				search: value,
				visible_for_employees: constantsGraphql.YES_NO,
				verified: constantsGraphql.YES_NO,
				//active: constantsGraphql.YES_NO,
			},
			callbackStart: setSearching.bind( this, true ),
			callbackError: setSearching.bind( this, false ),
			/* TODO optimize */
			callbackSuccess: ( { employees } ) => {
				setSearching( false )
				setEmployees( employees )
			}
		})
	}
	
	useEffect( () => {
		fetchEmployees()
		
		navigation.addListener( 'focus', e => {
			fetchEmployees()
		});
		
		return () => {
			return navigation.removeListener('focus');
		}
	}, [] )
	
	const filters = _.size( search ) > 2 ? [ {field: 'name', kind: 'contains', value: search } ] : null;
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:pages.teams.teams.input_search_employee'),
					onChangeText: _.debounce( fetchEmployees, 400 )
				}
			]}
			//addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TEAMS ) ? { onPress: createTeam } : null }
		/>
	);
	
	return (
		<ManagementGroupedThemeList
			header={ header }
			items={ employees }
			renderItem={ renderItem.bind( this ) }
			groupByKey={ 'active' }
			isSearching={ searching }
			filters={ filters }
			groupByValues={ [
				constantsActive.YES,
				constantsActive.NO
			] }
		/>
	)
}

export default TeamsEmployees
